let constants = {
  uniqueProductName: "platform"
};

export default constants;
